import { UncubesQuery } from '@dynameat/views/reporting/models/uncubesQuery';

export class AverageTicketQuery extends UncubesQuery {
  projection = 'group_ticket_sales'

  cuts = []

  aggregates = [
    { kpi: 'ticket_count', function: 'SUM' }
  ]

  limit = 25

  constructor(pointOfSaleGuid, dateStart, dateEnd, isManaged) {
    super();
    this.cuts = [
      { expression: `point_of_sale_guid = '${pointOfSaleGuid}'` },
      { expression: `group_ticket_line_date between '${dateStart}' and '${dateEnd}'` }];
    if (isManaged) {
      this.aggregates.push({ kpi: 'group_ticket_line_amount_managed', function: 'SUM' });
    } else {
      this.aggregates.push({ kpi: 'group_ticket_line_amount', function: 'SUM' });
    }
  }
}
